"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var menu_item_1 = require("../../models/menu-item");
var SideMenuItemComponent = (function () {
    function SideMenuItemComponent(_router) {
        this._router = _router;
        this.itemClicked = new core_1.EventEmitter();
        this.expanded = false;
    }
    SideMenuItemComponent.prototype.ngOnInit = function () { };
    SideMenuItemComponent.prototype.onItemClicked = function (e) {
        e.preventDefault();
        if (!this.item.children) {
            this.itemClicked.emit(this.item);
        }
        if (this.item.children && this.item.children.length > 0) {
            this.expanded = !this.expanded;
            return;
        }
        if (this.item.route) {
            this._router.navigate([this.item.route]);
        }
        else if (this.item.url) {
            this._router.navigateByUrl(this.item.url);
        }
        else if (this.item.externalUrl) {
            window.open(this.item.externalUrl);
        }
    };
    return SideMenuItemComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], SideMenuItemComponent.prototype, "alt", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", menu_item_1.MenuItem)
], SideMenuItemComponent.prototype, "item", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], SideMenuItemComponent.prototype, "itemClicked", void 0);
SideMenuItemComponent = __decorate([
    core_1.Component({
        selector: 'side-menu-item',
        template: "\n      <li [ngClass]=\"{ 'active': active, 'toggled': expanded, 'sub-menu': item.children }\" (click)=\"onItemClicked($event)\"><a href=\"\" (click)=\"$event.preventDefault()\" [class.fc-alt]=\"alt\"><i class=\"zmdi zmdi-{{item.icon}}\" *ngIf=\"item.icon\"></i>{{item.title}}</a><ul [@isVisibleChanged]=\"expanded\" *ngIf=\"item.children\"><side-menu-item [item]=\"child\" *ngFor=\"let child of item.children\"></side-menu-item></ul></li>\n    ",
        animations: [
            core_1.trigger('isVisibleChanged', [
                core_1.state('true', core_1.style({ opacity: 1 })),
                core_1.state('false', core_1.style({ opacity: 0, height: 0 })),
                core_1.transition('* => *', core_1.animate('.2s')),
            ]),
        ],
    }),
    __metadata("design:paramtypes", [router_1.Router])
], SideMenuItemComponent);
exports.SideMenuItemComponent = SideMenuItemComponent;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/user-interface/side-menu/side-menu-item.component.js
// module id = 115
// module chunks = 0